export default __webpack_public_path__ + "static/media/1@2x.448b7939.png";